import {parsers} from './parser';

export enum PostAuthBehaviour {
  Default = 'default',
  GoToStore = 'go-to-store',
}

export type FeatureFlags = keyof typeof parsers;
export type FallbackValues<TFlag extends FeatureFlags = FeatureFlags> = Parameters<
  typeof parsers[TFlag]
>[0];
export type ReturnValue<TFlag extends FeatureFlags = FeatureFlags> = ReturnType<
  typeof parsers[TFlag]
>;

/**
 * Retrieve a feature flag value from the provider context, for a given flag
 * name and optionally with a fallback value.
 */
export type FlagValueGetter = <TFlag extends FeatureFlags>(
  flag: TFlag,
  fallbackValue?: FallbackValues<TFlag>,
) => ReturnValue<TFlag>;

export type FeatureFlagContext = {
  getFlagValue: FlagValueGetter;
};
